const docx = require("docx");
const { StyleLevel, TableOfContents } = docx;

export const TOC = () => [
    new TableOfContents("Summary", {
        hyperlink: true,
        headingStyleRange: "1-5",
        stylesWithLevels: [new StyleLevel("MySpectacularStyle", 1)],
    }),
]